import type { FileError } from 'react-dropzone';

import { fileSizeError, maxCSVFileSize } from './constants';

export const csvFileValidator = (file: File): FileError | FileError[] | null => {
  if (file.size > maxCSVFileSize) {
    return fileSizeError;
  }

  return null;
};
